export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="100%" height="100%">
    <g>
      <path
        d="M50 32c0-9.941-8.059-18-18-18s-18 8.059-18 18c0 6.628 3.588 12.422 8.929 15.556l-4.465 8.93C17.169 55.833 16 54.618 16 53.333V48c0-1.657-1.343-3-3-3s-3 1.343-3 3v5.333c0 4.418 3.582 8 8 8 2.209 0 4.209-.895 5.657-2.343l6.343-6.343c1.657.448 3.418.686 5.237.686 1.819 0 3.58-.238 5.237-.686l6.343 6.343C47.791 60.438 49.791 61.333 52 61.333c4.418 0 8-3.582 8-8V48c0-1.657-1.343-3-3-3s-3 1.343-3 3v5.333c0 1.285-1.169 2.5-2.464 1.843l-4.465-8.93C41.412 44.422 45 38.628 45 32z"
        fill="#4A90E2"
      />
      <circle cx="26" cy="28" r="2.5" fill="#fff" />
      <circle cx="38" cy="28" r="2.5" fill="#fff" />
      <path d="M32 36c-3.314 0-6-2.686-6-6h12c0 3.314-2.686 6-6 6z" fill="#fff" opacity="0.5" />
    </g>
  </svg>
);
